// modules
import { handleActions } from 'redux-actions'

// actions
import {
  setMedicalDeviceOrderingList,
  setMedicalDeviceOrderingEditOrder,
  setMedicalDeviceOrderingPatientAddresses,
  setMedicalDeviceOrderingPatientProfile,
  setMedicalDeviceOrderingTypeList,
  resetMedicalDeviceOrdering
} from 'src/store/modules/actions/medicalDeviceOrdering'

const initialState = {
  orderList: [],
  editOrder: {},
  patientAddresses: [],
  patientProfile: {},
  typeList: []
}

export default handleActions(
  {
    [setMedicalDeviceOrderingList](state, { payload: orderList }) {
      return {
        ...state,
        orderList
      }
    },

    [setMedicalDeviceOrderingEditOrder](state, { payload: editOrder }) {
      return {
        ...state,
        editOrder
      }
    },

    [setMedicalDeviceOrderingPatientAddresses](
      state,
      { payload: patientAddresses }
    ) {
      return {
        ...state,
        patientAddresses
      }
    },

    [setMedicalDeviceOrderingPatientProfile](
      state,
      { payload: patientProfile }
    ) {
      return {
        ...state,
        patientProfile
      }
    },

    [setMedicalDeviceOrderingTypeList](state, { payload: typeList }) {
      return {
        ...state,
        typeList
      }
    },

    [resetMedicalDeviceOrdering]() {
      return initialState
    }
  },
  initialState
)
